export type CompCoveredDetail = {
  label: string;
  description: string;
};

export const compCoveredDetails: CompCoveredDetail[] = [
  {
    label: 'Damage to your car',
    description:
      'For accidental and malicious damage, storm, fire, flood & hail.',
  },
  {
    label: `Damage to another person's car or property (legal liability)`,
    description:
      'If done while using your car, attached trailer or caravan, up to $20 million.',
  },
  {
    label: 'Damage to your car by an uninsured driver',
    description:
      'Up to the sum insured on your Certificate of Insurance or market value.',
  },
  {
    label: 'Emergencies',
    description:
      'Cover for emergency repairs, towing or accommodation after a covered incident.',
  },
  {
    label: 'Car hire if yours is stolen',
    description: 'Up to $75 per day for up to 14 days.',
  },
  {
    label: 'A Stolen car',
    description: 'Whether your car is found or not.',
  },
  {
    label: 'Stolen keys replacement',
    description:
      'A new set if yours are stolen. Cover up to $1,000 in any one period of insurance.',
  },
  {
    label: 'Personal property in your car after a covered incident',
    description: 'Up to $500 per policy period. Exclusions apply.',
  },
  {
    label: 'Grocery replacement',
    description:
      'Up to $200 per policy period for damaged or stolen groceries after a covered incident.',
  },
  {
    label: '2 years new-for-new car replacement',
    description: `If you're insured from the first rego and your car is written off.`,
  },
  {
    label: 'Trailer or caravan loss or damage',
    description: `Cover up to $1,000 in any one period of insurance if attached to your car when stolen or damaged.`,
  },
  {
    label: 'Child seats and baby capsules replacement',
    description: `Up to $500 in any one period of insurance when damaged in an insured event or stolen from your locked car.`,
  },
  {
    label: 'Towing and storage costs',
    description: `If your car is damaged and cannot be driven after an insured event.`,
  },
  {
    label: 'Lifetime repair guarantee on authorised repairs',
    description: `Guarantee on workmanship and materials on authorised repairs through our Partner Repair Network, for as long as you own the car.`,
  },
  {
    label: 'Temporary cover',
    description: `For up to 14 days when you replace your car during the period of insurance. Giving you time to apply for a change of cover. Limits apply.`,
  },
  {
    label: 'Optional extras also available',
    description: `Such as Roadside Assistance, Hire car after an incident, Windscreen/window glass cover, and Cover for drivers under 25 years old.`,
  },
];
